import { useReducer } from 'react';
import { ClientRegistrationDataResponse, FetchAction, FetchedData } from '../../types';

export type ApiDataReducerState = {
    registrationData: FetchedData<ClientRegistrationDataResponse | null>;
};

type Action = FetchAction<'GET_REGISTRATION_DATA', ClientRegistrationDataResponse>;

const INITIAL_STATE: ApiDataReducerState = {
    registrationData: {
        data: null,
        state: {
            loading: false,
            loaded: false,
            error: null,
        },
    },
};

function ApiDataReducer(state: ApiDataReducerState, action: Action): ApiDataReducerState {
    switch (action.type) {
        case 'GET_REGISTRATION_DATA':
            return {
                ...state,
                registrationData: updateFetchingAction(state.registrationData, action),
            };
        default: {
            return state;
        }
    }
}

function updateFetchingAction<D>(currentPartialState: FetchedData<D>, action: FetchAction<string, D>): FetchedData<D> {
    if (action.phase === 'start') {
        return {
            ...currentPartialState,
            state: {
                loading: true,
                loaded: false,
                error: null,
            },
        };
    }
    if (action.phase === 'success') {
        return {
            ...currentPartialState,
            data: action.payload.data,
            state: {
                loading: false,
                loaded: true,
                error: null,
            },
        };
    }
    if (action.phase === 'error') {
        return {
            ...currentPartialState,
            state: {
                loading: false,
                loaded: true,
                error: action.error,
            },
        };
    }
    return currentPartialState;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useApiDataReducer = () => useReducer(ApiDataReducer, INITIAL_STATE);
